import { createPinia } from "pinia"
import { createApp } from "vue"

import { useSessionStore } from "@/entities/session"

import App from "./App.vue"
import { router } from "./router"
import "./styles/main.css"

const app = createApp(App)
app.use(createPinia())

useSessionStore().hydrate()

app.use(router)
app.mount("#app")
